import { render, staticRenderFns } from "./PromotionInfo.vue?vue&type=template&id=668a8517&scoped=true&"
import script from "./PromotionInfo.vue?vue&type=script&lang=ts&"
export * from "./PromotionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a8517",
  null
  
)

export default component.exports